import React from 'react';
import { Card, Link } from '@amzn/storm-ui';
import styled from 'styled-components';
import { usePageHeaderBundle } from 'src/providers/PantherLocalizationProvider';

const HiddenCard = styled(Card)`
  position: fixed;
  top: -200px;
  right: -200px;
  width: fit-content;
  z-index: 1002;
  &:focus-within {
    top: 10px;
    right: 10px;
  }
`;

const SkipNavCard: React.VFC = () => {
  const headerTranslation = usePageHeaderBundle();
  return (
    <HiddenCard padding="xsmall">
      <Link href="#AACApplicationBody">
        {headerTranslation.getMessage('page-header-skip-to-main-content-label')}
      </Link>
    </HiddenCard>
  );
};

export default SkipNavCard;
